module.exports = __webpack_public_path__ + "static/img/logo.152e8335.svg";